module.exports = __webpack_public_path__ + "img/zoomCrop-256--tiny.95e741e8.png";